//@ts-strict-ignore
/*
 * A text field formatter for workspace fields that hides the value (Displays *'s) unless a provided condition is met.
 * Must set options: {condition: func} on the column override - Takes rowData and should return true/false.
 * */
import React from 'react';
import TextFieldFormatter from './TextFieldFormatter';

export const HiddenTextFormatter = ({ value: potentialValue, ...rest }) => {
  const value = rest.column.options?.condition?.(rest.dependentValues?.rowData)
    ? potentialValue
    : '*'.repeat(potentialValue?.length ?? 0);
  return <TextFieldFormatter {...rest} value={value} />;
};
